import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import { ErrorMessage, GetCommonData, Params } from "../../../../types";
import {
  PendingRequestData,
  PendingRequestDataParams,
} from "../../../../types/eventManage/pendingRequest";
import { handleApiError } from "../../../../utils/errorHandler";

// get all
export const getAllPendingRequestAsync = createAsyncThunk<
  GetCommonData<PendingRequestData>,
  Params<PendingRequestDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllPendingRequest", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as PendingRequestDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllPending, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get pending data fail");
    return rejectWithValue(error);
  }
});

// Delete Event
export const deleteEventAsync = createAsyncThunk<
  null,
  { data: { id: string }; others: { reRender?: (v: boolean) => void } }
>(
  "admin/deleteEvent",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.delete(`${BASE_API.deleteEvent}/${data.id}`, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender?.(true);
      toast("success", "Event deleted successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Event delete failed");
      return rejectWithValue(error);
    }
  }
);

// Delete Webinar
export const deleteWebinarAsync = createAsyncThunk<
  null,
  { data: { id: string }; others: { reRender?: (v: boolean) => void } }
>(
  "admin/deleteWebinar",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.delete(`${BASE_API.deleteWebinar}/${data.id}`, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender?.(true);
      toast("success", "Webinar deleted successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Webinar delete failed");
      return rejectWithValue(error);
    }
  }
);

// Delete Campaign
export const deleteCampaignAsync = createAsyncThunk<
  null,
  { data: { id: string }; others: { reRender?: (v: boolean) => void } }
>(
  "admin/deleteCampaign",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.delete(`${BASE_API.deleteCampaign}/${data.id}`, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender?.(true);
      toast("success", "Campaign deleted successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Campaign delete failed");
      return rejectWithValue(error);
    }
  }
);
